import PostListPage from '~/components/post/PostListPage'

export default PostListPage
